import { AddIcon } from '@chakra-ui/icons';
import {
    Flex,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    removeUser,
    setSelectedUser,
} from '../../../app-state/slices/ClientsSlice';
import { useCurrentColors } from '../../hooks/UseCurrentColors/UseCurrentColors';
import CanopyButton from '../CanopyButton/CanopyButton';
import IconButton from '../IconButton/IconButton';
import Tags from '../Tags/Tags';

function MobileUsers({
    users,
    groups,
    selectedUser,
    type,
    selectedMenu,
    t,
}: Clients & { type: ClientsTypes; selectedMenu: any; t: any }) {
    const [openModal, setOpenModal] = useState(false);
    const router = useNavigate();

    const btnRef: React.LegacyRef<HTMLButtonElement> = React.createRef();
    const currentColors = useCurrentColors();
    const dispatch = useDispatch();
    const mGroups: PortfolioUser[] = [];
    const onClose = () => {
        setOpenModal(false);
    };

    groups.forEach((group) => {
        if (group?.users?.length > 0) {
            mGroups.push({
                uniqueId: group.uniqueId,
                id: group.users?.map((u) => u.id).join(','),
                username: group.name,
                displayName: group.name,
                meta: group.users?.map((u) => u.displayName).join(','),
                users: group.users,
                type: 'GROUPED_CLIENT',
            });
        }
    });

    const items = users?.concat(mGroups) || [];

    return (
        <>
            <IconButton
                background="transparent"
                cursor="pointer"
                border="none"
                ref={btnRef}
                icon="NavClient"
                variant="ghost"
                aria-label="add-user"
                height="26px !important"
                width="26px !important"
                color={currentColors.contentText}
                onClick={() => {
                    setOpenModal(!openModal);
                }}
            />
            <Modal
                isCentered
                closeOnOverlayClick={false}
                onEsc={() => setOpenModal(false)}
                isOpen={openModal}
                size="6xl"
                onClose={onClose}>
                <ModalOverlay
                    style={{
                        backdropFilter: 'blur(5px)',
                    }}
                />
                <ModalContent
                    pt="35px"
                    borderRadius={'4px'}
                    backgroundColor={currentColors.componentBg}>
                    <ModalHeader
                        color={currentColors.brand['10']}
                        fontSize="20px"
                        fontWeight="bold"
                        height="70px"
                        flex="-1"
                        padding="0px 0px 0px 1rem">
                        {'Review Portfolios'}
                    </ModalHeader>
                    <ModalCloseButton
                        as={() => (
                            <IconButton
                                background="transparent"
                                cursor="pointer"
                                border="none"
                                display="inline-flex"
                                onClick={onClose}
                                color={currentColors.brand['500']}
                                width="24px"
                                height="24px"
                                aria-label="remove"
                                icon="ActClose"
                                variant="ghost"
                                position="absolute"
                                top="15px"
                                right="15px"
                            />
                        )}
                    />
                    <ModalBody
                        padding="0 15px"
                        maxHeight={'60vh'}
                        overflow="auto">
                        <Flex alignItems="center">
                            <Tags
                                flexWrap="wrap"
                                mx="10px"
                                items={items}
                                selected={selectedUser}
                                uniqueId={'uniqueId'}
                                dataKey="displayName"
                                tooltipKey="meta"
                                onClick={(user) => {
                                    dispatch(setSelectedUser({ user, type }));
                                    onClose();
                                }}
                                onDelete={(user) => {
                                    dispatch(removeUser({ user, type }));
                                }}
                            />
                        </Flex>
                        <CanopyButton
                            size="sm"
                            variant="ghost"
                            mt="20px"
                            pb="20px"
                            color={currentColors.primaryColor}
                            height="5rem"
                            onClick={() => {
                                router({ pathname: `/${selectedMenu}` });
                            }}>
                            <AddIcon
                                width={'12px !important'}
                                height={'12px !important'}
                                mr="4px"
                            />
                            {t('add-user')}
                        </CanopyButton>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
}
export default MobileUsers;
